import React, {Component} from 'react';
import {Form, Control, Fieldset} from "react-redux-form";
import {formatMoney} from "accounting-js";
import moment from "moment/moment";
import _ from 'lodash';
import EditStatus from "../forms/edit_status";
import NotificationStatus from "../forms/notification_status";

export default class ReportsExpensesEditForm extends Component{
    render(){
        const { reports, revision } = this.props;
        const { modality } = this.props.match.params;
        const { summary } = reports;
        const styleActions = {
            position: 'relative',
            display: 'inline',
            top: '1.7em',
            left: '-29px',
            width: '30px',
        }
        const styleActionButton = {
            display: 'inline',
            border: 0,
            backgroundColor: 'transparent',
            color: '#662d91',
            cursor: 'pointer'
        }
        let rc = _.find(revision.permissions, (o) => {return o==='Create'}) ? true:false;

        return(
            <div className="columns is-centered">
                <div className="column is-11">
                    <Form model="revision" onSubmit={(values) => this._submitForm(values)}>
                        <h1 className="title is-6">DATOS DEL PROYECTO</h1>
                        <table className="table is-fullwidth project-goal-table no-margin">
                            <tbody>
                            <tr>
                                <td colSpan={2} style={{width: '50%'}}>
                                    <span className="help is-dark">Titular</span>
                                    <strong>{!_.isEmpty(summary.data) ? `${summary.data.agency.owner.name} ${summary.data.agency.owner.last_name} ${summary.data.agency.owner.slast_name}`:'---'}</strong>
                                </td>
                                <td colSpan={modality === 'modalidad-ii' ? 1:2} style={{width: modality === 'modalidad-ii' ? '25%':'50%'}}>
                                    <span className="help is-dark">Entidad</span>
                                    {modality==='modalidad-ii' ?
                                        <strong>{this._stateName()}</strong>
                                        :<strong>{!_.isEmpty(summary.data) && summary.data.agency.agenciable ? summary.data.agency.agenciable.name : '---'}</strong>}
                                </td>
                                {modality === 'modalidad-ii' ?
                                    <td colSpan={1} style={{width: '25%'}}>
                                        <span className="help is-dark">Municipio</span>
                                        <strong>{!_.isEmpty(summary.data) && summary.data.agency.agenciable ? summary.data.agency.agenciable.name : '---'}</strong>
                                    </td>
                                    :null}
                            </tr>
                            <tr>
                                <td colSpan={4}>
                                    <span className="help is-dark">Instancia</span>
                                    <strong>{!_.isEmpty(summary.data) && summary.data.agency.name ? summary.data.agency.name : '---'}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={4}>
                                    <span className="help is-dark">Proyecto</span>
                                    <strong>{!_.isEmpty(summary.data) && summary.data.name ? summary.data.name : '---'}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td style={{width: '25%'}}>
                                    <div className="columns">
                                        <div className="column is-1">
                                            <i className="fa fa-usd fa-2x" />
                                        </div>
                                        <div className="column">
                                            <span className="help is-dark">Monto aprobado</span>
                                            <strong> {summary.data.amounts && summary.data.amounts.expenses ? `${formatMoney(summary.data.amounts.expenses.total)}` : '---'}</strong>
                                        </div>
                                    </div>
                                </td>
                                <td style={{width: '25%'}}>
                                    <div className="columns">
                                        <div className="column is-1">
                                            <i className="fa fa-usd fa-2x" />
                                        </div>
                                        <div className="column">
                                            <span className="help is-dark">Monto ejercido</span>
                                            <strong> {summary.data.amounts && summary.data.amounts.expenses ? `${formatMoney(summary.data.amounts.expenses.spent)}` : '---'}</strong>
                                        </div>
                                    </div>
                                </td>
                                <td style={{width: '25%'}}>
                                    <div className="columns">
                                        <div className="column is-1">
                                            <i className="fa fa-usd fa-2x" />
                                        </div>
                                        <div className="column">
                                            <span className="help is-dark">Monto por ejercer</span>
                                            <strong> {summary.data.amounts && summary.data.amounts.expenses ? `${formatMoney(summary.data.amounts.expenses.missing)}` : '---'}</strong>
                                        </div>
                                    </div>
                                </td>
                                <td style={{width: '25%'}}>
                                    <div className="columns">
                                        <div className="column is-1">
                                            <i className="fa fa-calendar" />
                                        </div>
                                        <div className="column">
                                            <span className="help is-dark">Periodo de ejecución</span>
                                            <strong>{_.capitalize(moment(summary.data.execution_start).format('MMMM YYYY'))} a {_.capitalize(moment(summary.data.execution_end).format('MMMM YYYY'))}</strong>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <h1 className="title is-6">GASTOS DE COORDINACIÓN</h1>
                        {!_.isEmpty(summary.data.project_expenses) ?
                            <Fieldset model=".reports.expenses.body" component="table" className="is-fullwidth table project-goal-table no-margin">
                                <tbody>
                                {_.map(summary.data.project_expenses, (row,k) =>{
                                    let expenseRevision = !_.isEmpty(revision.reports.expenses.body) && !_.isEmpty(revision.reports.expenses.body[row.id]) ? revision.reports.expenses.body[row.id]: undefined
                                    let expenseRevisionAllowEdit = expenseRevision && !_.isEmpty(expenseRevision.allow_edit) ? expenseRevision.allow_edit:'false';
                                    let expenseRevisionCdm = undefined; //let expenseRevisionCdmAllowEdit = undefined;
                                    let validCdm = false; let agencyId = undefined; let findAgency = undefined;
                                    if(modality === 'modalidad-iii'){
                                        validCdm = !_.isEmpty(revision.reports.expenses.agency) && !_.isEmpty(revision.reports.expenses.agency[k]) && revision.reports.expenses.agency[k].id !== '' ? true:false;
                                        agencyId = validCdm ? _.toNumber(revision.reports.expenses.agency[k].id):undefined;
                                        findAgency = _.find(row.project_expense_agencies, {id: agencyId})
                                        expenseRevisionCdm = findAgency && !_.isEmpty(revision.reports.expenses.body) && !_.isEmpty(revision.reports.expenses.body[row.id]) && !_.isEmpty(revision.reports.expenses.body[row.id].agencies) && !_.isEmpty(revision.reports.expenses.body[row.id].agencies[findAgency.agency_id]) ? revision.reports.expenses.body[row.id].agencies[findAgency.agency_id]: undefined
                                        //expenseRevisionCdmAllowEdit = expenseRevisionCdm && !_.isEmpty(expenseRevisionCdm.allow_edit) ? expenseRevisionCdm.allow_edit:'false';
                                    }
                                    return[
                                        <tr key={`concept-${k}`}>
                                            <td colSpan={modality !== 'modalidad-iii' ? 6:8} className="goal-cell">
                                                <span className="help is-white">Concepto</span>
                                                <strong>{row.expense_concept ? row.expense_concept.name:'---'}</strong>
                                            </td>
                                        </tr>,
                                        <tr key={`unit-${k}`}>
                                            <td colSpan={modality !== 'modalidad-iii' ? 6:8} >
                                                <span className="help is-dark">Unidad</span>
                                                <small><strong>{row.expense_unit ? row.expense_unit.name:'---'}</strong></small>
                                            </td>
                                        </tr>,
                                        modality === 'modalidad-iii' && !_.isEmpty(row.project_expense_agencies) ?
                                            <tr key={`cdms-${k}`}>
                                                <td colSpan={8}>
                                                    <div className="field is-grouped">
                                                        <div className="control">
                                                            <label htmlFor={`agency_id_${k}`} className="label">CDM'S</label>
                                                            <div className="select is-small">
                                                                <Control.select model={`revision.reports.expenses.agency[${k}].id`} name={`agency_id_${k}`} id={`agency_id_${k}`}>
                                                                    <option value=""> -- CDM'S --</option>
                                                                    {_.map(row.project_expense_agencies,(cdm, o) => {
                                                                        return <option key={o} value={cdm.id}>{cdm.agenciable && cdm.agenciable.name ? cdm.agenciable.name:'---'}</option>
                                                                    })}
                                                                </Control.select>
                                                            </div>
                                                        </div>

                                                        <div className="control">
                                                            <div className="notification is-info">
                                                                <p><i className="fa fa-info"/>&nbsp; Seleccionar CDM para llenar revisión </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            :null,
                                        <tr key={k}>
                                            <td style={{width: '5%', padding: '0em .5em 1em 30px'}}>
                                                {this.state.modalMessageExpensesShow && k === this.state.expenseIndex ?
                                                    <ModalMessageExpenses active={this.state.modalMessageExpensesShow} amountTotal={row.total} data={row.project_version_phase_expense} findAgency={findAgency} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
                                                <div className="control" style={styleActions}>
                                                    <button type="button" style={styleActionButton} onClick={() => this._showMessageExpenses(k)}><i className="fa fa-eye"></i></button>
                                                </div>
                                                <span className="help is-inm-purple">No.</span>
                                                <strong className="has-text-inm-purple">{k+1}</strong>
                                            </td>
                                            <td className="has-text-right" style={{width: '10%'}}>
                                                <span className="help is-dark">Valor unitario</span>
                                                <small>{formatMoney(row.amount ? row.amount:0)}</small>
                                            </td>
                                            <td className="has-text-centered">
                                                <span className="help is-dark">Cantidad</span>
                                                <small>{row.quantity}</small>
                                            </td>
                                            {modality === 'modalidad-iii' ?
                                                <td className="has-text-centered">
                                                    <span className="help is-dark">Instancia</span>
                                                    <span>{findAgency ? findAgency.agenciable.name:'---'}</span>
                                                </td>
                                                :null}
                                            <td className="has-text-right">
                                                <span className="help is-dark">Monto aprobado</span>
                                                <small><strong>{formatMoney(row.amounts.total)}</strong></small>
                                            </td>
                                            {modality==='modalidad-iii' ?
                                                <td className="has-text-right">
                                                    <span className="help is-dark">Monto ejercido desglosado</span>
                                                    {formatMoney(findAgency ? findAgency.amounts.spent:0)}
                                                </td>
                                                :null}
                                            <td className="has-text-right">
                                                <span className="help is-dark">Monto ejercido</span>
                                                <small><strong>{formatMoney(row.amounts.spent)}</strong></small>
                                            </td>
                                            <td className="has-text-right">
                                                <span className="help is-dark">Monto por ejercer</span>
                                                <small><strong>{formatMoney(row.amounts.missing)}</strong></small>
                                            </td>
                                        </tr>,
                                        <tr key={`exp-rev-${k}`}>
                                            <td colSpan={modality !== 'modalidad-iii' ? 6:8}>
                                                <span className="help is-dark">Revisión del gasto No. {k+1}</span>
                                                <div className="field has-addons">
                                                    <div className="control">
                                                        <div className="select is-small">
                                                            <Control model={`[${row.id}].status`} key={`status_${row.id}`} id={`status_${row.id}`} component={NotificationStatus} defaultValue={expenseRevision && expenseRevision.status ? expenseRevision.status : 'success'}  changeAction={(model,value) => this._changeStatus(model,value, {id: row.id, model:`revision.reports.expenses.body[${row.id}].id`})} />
                                                        </div>
                                                    </div>
                                                    <div className="control is-expanded">
                                                        <Control.text model={`[${row.id}].comment`} key={`comment_${row.id}`} id={`comment_${row.id}`} className="input is-small is-fullwidth" placeholder="Comentario"/>
                                                    </div>
                                                    <div className="control">
                                                        <div className="select is-small">
                                                            <Control model={`[${row.id}].allow_edit`} key={`edit_status_${row.id}`} id={`edit_status_${row.id}`} component={EditStatus} defaultValue={expenseRevisionAllowEdit}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>,
                                        modality === 'modalidad-iii' && findAgency ?
                                            <tr key={`exp-rev-cdm-${k}`}>
                                                <td colSpan={modality !== 'modalidad-iii' ? 6:8}>
                                                    <span className="help is-dark">{`Revisión del gasto No. ${k+1} por CDM - ${findAgency.agenciable.name}`}</span>
                                                    <div className="field has-addons">
                                                        <div className="control">
                                                            <div className="select is-small">
                                                                <Control model={`[${row.id}].agencies[${findAgency.agency_id}].status`} key={`status_${row.id}_rev${findAgency.agency_id}`} id={`status_${row.id}_rev${findAgency.agency_id}`}  component={NotificationStatus} defaultValue={expenseRevisionCdm && expenseRevisionCdm.status ? expenseRevisionCdm.status : 'success'} changeAction={(model,value) => this._changeStatus(model,value, {id: row.id, model:`revision.reports.expenses.body[${row.id}].agencies[${findAgency.agency_id}].id`})} />
                                                            </div>
                                                        </div>
                                                        <div className="control is-expanded">
                                                            <Control.text model={`[${row.id}].agencies[${findAgency.agency_id}].comment`} key={`comment_${row.id}_rev${findAgency.agency_id}`} id={`comment_${row.id}_rev${findAgency.agency_id}`} className="input is-small is-fullwidth" placeholder="Comentario"/>
                                                        </div>
                                                        {/*<div className="control">
														<div className="select is-small">
															<Control model={`[${row.id}].agencies[${agencyId}].allow_edit`} key={`edit_status_${row.id}_rev${agencyId}`} id={`edit_status_${row.id}_rev${agencyId}`} component={EditStatus} defaultValue={expenseRevisionCdmAllowEdit}/>
														</div>
													</div>*/}
                                                    </div>
                                                </td>
                                            </tr> :null
                                    ]
                                })}
                                </tbody>
                            </Fieldset>
                            :<p>Ningún gasto de coordinación guardado</p> }

						{!_.isEmpty(revision.notifications_types) ?
						<div className="fieldset">
							<legend>NOTIFICACIÓN</legend>
							<div className="columns">
								<div className="column">
									<div className="field is-grouped is-grouped-multiline">
										<div className="control">
											<label htmlFor="" className="label">Tipo de notificación</label>
											<div className="select">
												<Control.select model="revision.reports.expenses.notification_type_id" id="notification_type_id">
													<option value="" defaultValue>--- Tipo ---</option>
													{_.map(revision.notifications_types, (opc, k) => {
														return <option value={opc.id} key={k}>{opc.name}</option>
													})}
												</Control.select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> :''}

                        <div className="field is-grouped is-grouped-right">
                            <div className="control">
                                <button type="button" className="button is-large" onClick={() => this.props.history.goBack()}>
                                    Regresar
                                </button>
                            </div>

                            {rc ?
                                <div className="control">
                                    <Control.button model="revision" className="button is-large is-primary">
                                        Guardar
                                    </Control.button>
                                </div> :''}
                        </div>
                    </Form>
                </div>
            </div>
        )
    }

    constructor() {
        super();
        this.state = {
            expenseIndex: undefined,
            modalMessageExpensesShow: false
        }
    }

    _submitForm(values){
        let { modality, state, municipality } = this.props.match.params;
        this.props.saveRevisionReportsExpenses(modality, state, municipality, values);
    }

    _stateName() {
        let { entities, reports } = this.props;
        if(!_.isEmpty(reports.summary.data)){
            let state = _.find(entities.list, {id: reports.summary.data.agency.agenciable.state_id});
            return state ? state.name : '---'
        }else {
            return '---'
        }
    }

    _changeStatus(model, values, field) {
        this.props.change(model, values);
        this.props.change(field.model, field.id);
    }

    _showMessageExpenses(indexExpense){
        this.setState({
            modalMessageExpensesShow: true,
            expenseIndex: indexExpense
        })
    }

    _toggleModal() {
        this.setState({
            modalMessageExpensesShow: false
        });
    }
}

class ModalMessageExpenses extends Component {
    render(){
        let { data, amountTotal, match, findAgency } = this.props;
        let {modality} = match.params;
        return (
            <div className={`modal${this.props.active ? ' is-active' : ''}`}>
                <div className="modal-background" onClick={this.props.closeModal}></div>
                <div className="modal-content" style={{height: (!_.isEmpty(data) && _.isEmpty(data.invoices)) || (_.isEmpty(data)) ? 'auto':''}}>
                    <div className="message">
                        <div className="message-header">
                            <p>Gastos de la meta</p>
                            <button className="delete" aria-label="delete" onClick={this.props.closeModal}></button>
                        </div>
                        <div className="message-body">
                            <div className="columns">
                                <div className="column is-6">
                                    <p>Monto aprobado</p>
                                    <p><strong>{formatMoney(amountTotal)}</strong></p>
                                </div>
                                <div className="column is-6">
                                    <p>Monto ejercido</p>
                                    <p><strong>{formatMoney(data && data.amounts.spent_total ? data.amounts.spent_total:0)}</strong></p>
                                </div>
                            </div>

                            <div className="columns">
                                {modality === 'modalidad-iii' && findAgency && !_.isEmpty(findAgency.amounts) ?
                                    <div className="column is-6">
                                        <p>{`Monto ejercido - ${findAgency.agenciable.name}`}</p>
                                        <p><strong>{formatMoney(findAgency.amounts.spent)}</strong></p>
                                    </div>
                                    :''}
                                <div className="column is-6">
                                    <p>Monto por ejercer</p>
                                    <p><strong>{formatMoney(data && data.amounts.missing ? data.amounts.missing:amountTotal)}</strong></p>
                                </div>
                            </div>



                            {!_.isEmpty(data) && !_.isEmpty(data.invoices) ?
                                <fieldset className="fieldset">
                                    <legend>Facturas</legend>
                                    <table className="inm-table">
                                        <thead>
                                        <tr>
                                            <th>Factura</th>
                                            <th>PDF</th>
                                            <th>XML</th>
                                            <th>SAT</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {_.map(data.invoices, (item,k) => {
                                            return(
                                                <tr key={k}>
                                                    <td>{`${item.date} - ${formatMoney(item.total)}`}</td>

                                                    <td>
                                                        <div className="control">
                                                            <a href={item.pdf}  className="button is-info" target="_blank">
                                                                <span className="icon"><i className="fa fa-eye"/></span>
                                                            </a>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="control">
                                                            <a href={item.xml}  className="button is-info" target="_blank">
                                                                <span className="icon"><i className="fa fa-eye"/></span>
                                                            </a>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="control">
                                                            <a href={item.sat}  className="button is-info" target="_blank">
                                                                <span className="icon"><i className="fa fa-eye"/></span>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </fieldset>
                                :''}

	                        {!_.isEmpty(data) && !_.isEmpty(data.receipts) ?
		                        <fieldset className="fieldset">
			                        <legend>Comprobantes</legend>
			                        <table className="inm-table">
				                        <thead>
				                        <tr>
					                        <th>Comprobante</th>
					                        <th>Archivo</th>
					                        <th>Concepto</th>
				                        </tr>
				                        </thead>
				                        <tbody>
				                        {_.map(data.receipts, (item,k) => {
					                        return(
						                        <tr key={k}>
							                        <td>{`${item.date} - ${formatMoney(item.total)}`}</td>

							                        <td>
								                        <div className="control">
									                        <a href={item.file}  className="button is-info" target="_blank">
										                        <span className="icon"><i className="fa fa-eye"/></span>
									                        </a>
								                        </div>
							                        </td>

							                        <td>{item.concepts}</td>
						                        </tr>
					                        )
				                        })}
				                        </tbody>
			                        </table>
		                        </fieldset>
		                        :''}
                        </div>
                    </div>
                </div>
                <button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/elements/revision/reports_expenses.jsx